<template>
  <sc-chart :options="chartData" />
</template>
<script>
  import { createNamespacedHelpers } from 'vuex';
  import { ScChart } from '@intelipost-js/secure-components';

  const { mapState } = createNamespacedHelpers('analytic/providerBeta');

  export default {
    name: 'sc-chart-provider-ship-state',
    computed: {
      ...mapState([
        'chartShipmentForState',
      ]),
      summaries() {
        return this.chartShipmentForState.items || [];
      },
      providers() {
        return this.summaries.map(item => item.state_code);
      },
      inTime() {
        return this.summaries.map(item => item.in_time);
      },
      outOfTime() {
        return this.summaries.map(item => item.delayed);
      },
      chartData() {
        const { total_in_time = 0, total_delayed = 0 } = this.chartShipmentForState;

        return {
          chart: {
            type: 'column',
          },
          title: {
            text: `Entregas por estado (Total: ${total_in_time + total_delayed} entregas)`,
          },
          xAxis: {
            categories: this.providers,
          },
          yAxis: {
            min: 0,
            title: {
              text: '',
            },
          },
          plotOptions: {
            column: {
              stacking: 'normal',
            },
          },
          tooltip: {
            backgroundColor: 'white',
            useHTML: true,
            headerFormat: '<h3>{point.key}</h3>',
            pointFormat: '<span style="color:{series.color};font-weight:bold;">{series.name}: {point.y}</span><br/>',
            shared: true,
          },
          series: [
            {
              name: 'Atrasado',
              data: this.outOfTime,
              color: '#da6f6f',
            },
            {
              name: 'No Prazo',
              data: this.inTime,
              color: '#a4c25c',
            },
          ],
        };
      },
    },
    components: {
      ScChart,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/reports/pages/provider-beta/components/sc-chart-provider-ship-state/ScChartProviderShipState.vue